var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1806 6.3747C9.56736 5.7288 10.1794 4.80438 10.9525 3.91735H10.9534C11.6081 3.16453 12.8902 2.19831 12.8902 2.19831C13.083 2.05267 13.0623 1.84983 12.8432 1.74776L11.2935 1.02353C11.0744 0.921013 10.7765 0.995812 10.6313 1.18897C10.6313 1.18897 9.48508 2.83322 8.13604 6.33335C3.96484 4.44666 0 7.08925 0 11.6845C0 16.4844 3.69292 23.7755 8.68692 21.5746C13.9467 23.8507 17.3765 16.4848 17.3765 11.6845C17.3765 7.04965 13.8125 4.33227 9.1806 6.3747Z",
    fill: "#49712B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24657 4.82018C8.48769 4.79994 8.70065 4.58654 8.72001 4.34586C8.72001 4.34586 8.87489 2.46886 7.56677 1.15945C6.25469 -0.150405 4.38117 0.00579219 4.38117 0.00579219C4.14005 0.0260318 3.92709 0.239428 3.90729 0.480103C3.90729 0.480103 3.74977 2.35799 5.05965 3.66784C6.36865 4.97637 8.24657 4.82018 8.24657 4.82018Z",
    fill: "#49712B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.cdc830fe5780812cce44d8131230bcc8.svg";
export { ForwardRef as ReactComponent };